const downloadOrViewPdfFile = (file, fileName, isView = false) => {
  const fileURL = URL.createObjectURL(file);
  if (isView) {
    window.open(fileURL, '_blank');
  } else {
    const link = document.createElement('a');
    link.href = fileURL;
    link.download = fileName;

    link.click();
  }
};

export default downloadOrViewPdfFile;
